import FeedbackAPI from './Services/FeedbackAPI'
// FeedbackAPI
export default {
  FeedbackAPI,
}
